(function () {
  'use strict'

  /**
     * @ngdoc module
     * @name thismomentGlowModuleContest
     * @module thismoment.glow.component.module.contest
     *
     * @description
     * Embeds a configurable contest playlist into a Glow page.
     */

  const MODULE_NAME = 'thismoment.glow.component.module.contest'
  const COOKIE_NAME = 'tm_contest'
  const templateUrl = require('./tpl/module-contest.html')

  angular
    .module(MODULE_NAME, [
      require('angular-cookies'),
      'uuid4',
      require('../../../../playlist')
    ])
    .component('thismomentGlowModuleContest', {
      templateUrl: templateUrl,
      bindings: {
        trackEvent: '&',
        moduleId: '<',
        name: '<',
        cardOptions: '<',
        cardSharing: '<',
        contestActive: '<',
        loaderColor: '<',
        maxColumnCount: '<',
        playlistId: '<',
        playlistOrder: '<',
        playlistSearch: '<',
        voteButtonCtaColor: '<',
        voteButtonCtaFontColor: '<',
        voteButtonCtaText: '<',
        voteButtonCtaCompleteText: '<',
        voteButtonSubmitColor: '<',
        voteButtonSubmitText: '<'
      },
      controller: glowContestController
    })

  glowContestController.$inject = ['$cookies', '$location', '$state', 'uuid4', 'SdkConfig', 'Content', 'PlaylistContent', 'ExpandedContent']
  function glowContestController ($cookies, $location, $state, uuid4, SdkConfig, Content, PlaylistContent, ExpandedContent) {
    const vm = this

    vm.$onInit = contestInit

    function contestInit () {
      let contestUserId = ''
      const contestCookie = $cookies.getObject(COOKIE_NAME)
      if (angular.isObject(contestCookie)) {
        contestUserId = uuid4.validate(contestCookie.userId) ? contestCookie.userId : setNewContestUser()
      } else {
        contestUserId = setNewContestUser()
      }

      vm.loadItems = loadItems
      vm.cardOptions.card_vote_display = {
        contestActive: vm.contestActive,
        id: vm.moduleId,
        userId: contestUserId,
        voteButtonCtaColor: vm.voteButtonCtaColor,
        voteButtonCtaFontColor: vm.voteButtonCtaFontColor,
        voteButtonCtaText: vm.voteButtonCtaText,
        voteButtonCtaCompleteText: vm.voteButtonCtaCompleteText,
        voteButtonSubmitColor: vm.voteButtonSubmitColor,
        voteButtonSubmitText: vm.voteButtonSubmitText,
        votes: {}
      }

      // Deeplink logic
      // TODO: this is a temp solution until we revisit ui-router glow routes...
      // for now a glow playlist module will look for ?playlistId&contentId in the URL
      // and will render a deeplink to that content if
      // (a) the requested playlist id === the module playlist id
      // (b) the requested content is in the playlist
      var params = $location.search()
      if ('playlistId' in params && params.playlistId === vm.playlistId && 'contentId' in params) {
        var options = angular.extend(vm.cardOptions, { displayShare: true, playlistId: params.playlistId })
        PlaylistContent
          .get(
            {
              playlist_id: params.playlistId,
              content_id: params.contentId
            },
            function (response) {
              if ('content' in response.data) {
                Content.addContent('deeplink', response.data.content)
                ExpandedContent.open(response.data.content, options)
              } else {
                $state.go('glow.page')
              }
            }
          )
      }

      vm.displaySearch = vm.playlistSearch
      vm.paginatorLimit = SdkConfig.get('is_mobile') ? 8 : 16

      function loadItems (limit, offset, search, order, randomcontent, success, error) {
        return PlaylistContent.get({
          playlist_id: vm.playlistId,
          limit: limit,
          offset: offset,
          search_query: search,
          order: order,
          random_content: randomcontent,
          meta: false
        }, (response) => {
          var items = response.data.content
          if (typeof success === 'function') success(items)
          return items
        }, error)
      }
    }

    function setNewContestUser () {
      const id = uuid4.generate()

      $cookies.putObject(COOKIE_NAME,
        { userId: id },
        { expires: (new Date(Math.pow(2, 32) * 1000)).toUTCString() }
      )

      return id
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-contest/index.js